export default {
  header: {
    notes: 'Header for listing delivery points',
    message: 'Delivery points',
  },
  model: {
    address: {
      notes: 'Address field for delivery points',
      message: 'Address',
    },
    deliverySequenceId: {
      notes: 'Delivery Sequence ID field for delivery points',
      message: 'Delivery Sequence ID',
    },
    sandvikId: {
      notes: 'Sandvik ID field for delivery points',
      message: 'Sandvik ID',
    },
    mdgStatus: {
      notes: 'Mdg status field for delivery points',
      message: 'Mdg status',
      values: {
        a: {
          notes: 'Field for delivery point status indicating it is active',
          message: 'Active',
        },
        d: {
          notes:
            'Field for delivery point status indicating it is marked for deletion',
          message: 'Marked for deletion',
        },
        i: {
          notes: 'Field for delivery point status indicating it is inactive',
          message: 'Inactive',
        },
        l: {
          notes:
            "Field for delivery point status indicating it's legal status is questionable",
          message: 'Legal status',
        },
        p: {
          notes: 'Field for delivery point status indicating it is pending',
          message: 'Pending',
        },
        s: {
          notes: 'Field for delivery point status indicating it is suspended',
          message: 'Suspended',
        },
        u: {
          notes: 'Field for delivery point status indicating it is uncertain',
          message: 'Uncertain dept.',
        },
      },
    },
  },
};
